import { createApp } from 'vue'
import { createAuth } from '@websanova/vue-auth/dist/v3/vue-auth.esm.js'
import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js'
import VueAxios from 'vue-axios'
import { createGtm } from '@gtm-support/vue-gtm'
import Rollbar from 'rollbar'

import store from '@/store'
import router from '@/router'
import App from '@/App.vue'
import GlobalMixin from '@/mixins/GlobalMixin'
import { toNative } from 'vue-facing-decorator'
import httpClient from '@/plugins/axios'
import routerDriver from '@/plugins/auth-router-driver'
import authTokenDriver from '@/plugins/auth-token-driver'
import { setAuthClient } from '@/plugins/auth-client'
import bootstrapVue from '@/plugins/bootstrap-vue'
import i18n from '@/plugins/i18n'
import utils from '@/plugins/utils'
import constants from '@/plugins/constants'
import linkified from '@/plugins/linkified'

const app = createApp(App)

app.use(store)
app.use(VueAxios as any, httpClient as any)
app.use(bootstrapVue)
app.use(i18n)
app.use(utils)
app.use(constants)
app.directive('linkified', linkified)
app.mixin(toNative(GlobalMixin) as any)

const auth = createAuth({
  plugins: {
    http: httpClient,
    router
  },
  drivers: {
    auth: authTokenDriver,
    http: driverHttpAxios,
    router: routerDriver
  },
  options: {
    tokenDefaultKey: 'auth_access_token',
    refreshTokenKey: 'auth_refresh_token',
    parseUserData: (data: any) => data.user,
    authRedirect: (currentRoute: any) => ({
      path: '/auth/verify-email',
      query: { redirect_path: currentRoute.fullPath || '/' }
    }),
    refreshData: {
      url: '/auth/refresh',
      method: 'POST',
      enabled: true,
      interval: 15
    }
  }
})

setAuthClient(auth)
app.use(auth)
// vue-auth が認証ガードを登録してから初回ナビゲーションを開始する。
// 先に router を install すると、直リンク時だけ未認証判定を通らない。
app.use(router)

if (process.env.MIX_APP_ENV !== 'local') {
  const rollbar = new Rollbar({
    accessToken: process.env.MIX_ROLLBAR_JS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.MIX_APP_ENV
  })
  app.config.globalProperties.$rollbar = rollbar
  app.config.errorHandler = (error) => {
    rollbar.error(error as Error)
    throw error
  }
}

if (process.env.MIX_GTM_ID) {
  app.use(
    createGtm({
      id: process.env.MIX_GTM_ID,
      defer: false,
      compatibility: false,
      enabled: true,
      debug: process.env.NODE_ENV !== 'production',
      loadScript: true,
      vueRouter: router,
      trackOnNextTick: false
    })
  )
}

router.isReady().then(() => app.mount('#app'))
